export class TaskPermission {
    TSK_Add_Unit: boolean = false;
    TSK_Add: boolean = false;
    TSK_Admin_Unit: boolean = false;
    TSK_Admin: boolean = false;
    TSK_View_Unit: boolean = false;
    TSK_View: boolean = false;
    TSK_Own: boolean = false;
}